import React from "react";
import PricingHeroSection from "../../components/PricingHeroSection/index";
import PricingHeroSection2 from "../../components/PricingHeroSection2/index";
// import FAQs from "../../components/FAQs/index";
import Footer from "../../components/Footer/Footer";
const pricing = () => {
  return (
    <>
      <PricingHeroSection />
      <PricingHeroSection2 />
      {/* <FAQs /> */}
      <Footer />
    </>
  );
};

export default pricing;
